import Chaplin from 'chaplin';
import $ from 'jquery';

const Feedback = Chaplin.Model.extend({
  initialize: function () {
    const overrides = this.get(this.get('feedbackState'));
    const newAttributes = $.extend(true, this.serialize(), overrides);
    this.set(newAttributes);
  },
});

export default Feedback;
